import React from 'react'
import PropTypes from 'prop-types'
import Component from '../common/Component'
import withRouter from '../../lib/withRouter'
import IndexComponent from '../common/IndexComponent'
import actions from '../../actions/CarrierBrands'
import connectIndex from '../../lib/connectIndex'

export class CarrierBrandIndex extends Component {
  static propTypes = {
    location: PropTypes.object,
    index: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    pagination: PropTypes.object,
    records: PropTypes.array,
    flashMessages: PropTypes.array.isRequired,
    filters: PropTypes.object,
    searchColumns: PropTypes.array,
    history: PropTypes.func.isRequired
  }

  static defaultProps = {
    searchColumns: ['name', 'uuid']
  }

  static columns = [
    { key: 'name', label: 'Name', sortable: true },
    { key: 'uuid', label: 'UUID', sortable: true }
  ]

  render() {
    return (
      <div className="content">
        <IndexComponent
          fetchRecords={this.props.index}
          resetRecords={this.props.reset}
          location={this.props.location}
          path="/carrier_brands"
          name="Carrier Brand"
          pagination={this.props.pagination}
          columns={CarrierBrandIndex.columns}
          flashMessages={this.props.flashMessages}
          records={this.props.records}
          filterValues={this.props.filters}
          searchPlaceholder="Search by Name or UUID"
          searchColumns={this.props.searchColumns}
          history={this.props.history}
          filterable
        />
      </div>
    )
  }
}

const filters = []

export default connectIndex(withRouter(CarrierBrandIndex), 'carrierBrands', actions, filters)
